import React from 'react';
import PropTypes from 'prop-types';

import TourCardImage from 'app/shared/components/postingPath/TourCard/TourCardImage';
import TourCardDetails from 'app/shared/components/postingPath/TourCard/TourCardDetails';
import TourCardEditableControls from 'app/shared/components/postingPath/TourCard/TourCardEditableControls';
import TourCardContentContainer from 'app/shared/components/postingPath/TourCard/TourCardContentContainer';
import TourCardContainer from 'app/shared/components/postingPath/TourCard/TourCardContainer';
import TourCardEmpty from 'app/shared/components/postingPath/TourCard/TourCardEmpty';

const propTypes = {
    tour: PropTypes.shape({
        name: PropTypes.string.isRequired,
        createdDate: PropTypes.string.isRequired,
        creatorName: PropTypes.string.isRequired,
        imageSrc: PropTypes.string,
        state: PropTypes.oneOf(['active', 'inactive', 'empty']),
    }).isRequired,
    tourType: PropTypes.oneOf(['amenity', 'floorPlan', 'unit', 'singleFamily']).isRequired,
    hasBigBottomBorder: PropTypes.bool,
    isHidden: PropTypes.bool,
    isDisabled: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'md']), // sets bigger container height and content padding
    formData: PropTypes.object.isRequired,
    updateStatusMessage: PropTypes.func.isRequired,
    updateFormData: PropTypes.func.isRequired,
};

const defaultProps = {
    hasBigBottomBorder: true,
    isHidden: false,
    isDisabled: false,
    size: 'sm',
};

const TourCardEditable = ({
    tour,
    tourType,
    hasBigBottomBorder,
    isHidden,
    isDisabled,
    showPublish,
    size,
    formData,
    floorPlanIndex,
    unitIndex,
    updateStatusMessage,
    updateFormData,
}) => {
    return (
        <TourCardContainer
            hasBigBottomBorder={hasBigBottomBorder}
            size={size}
        >
            <TourCardImage
                imageSrc={tour.imageSrc}
                tourState={tour.state}
                isHidden={isHidden}
                size={size}
            />
            <TourCardContentContainer size={size}>
                {tour.state === 'empty' ? (
                    <TourCardEmpty
                        floorPlanIndex={floorPlanIndex}
                        formData={formData}
                        isDisabled={isDisabled}
                        isHidden={isHidden}
                        tour={tour}
                        tourType={tourType}
                        unitIndex={unitIndex}
                        updateFormData={updateFormData}
                        updateStatusMessage={updateStatusMessage}
                    />
                ) : (
                    <React.Fragment>
                        <TourCardDetails tour={tour} size={size} />
                        {!isDisabled && (
                            <TourCardEditableControls
                                floorPlanIndex={floorPlanIndex}
                                formData={formData}
                                showPublish={showPublish}
                                size={size}
                                tour={tour}
                                tourType={tourType}
                                unitIndex={unitIndex}
                                updateFormData={updateFormData}
                                updateStatusMessage={updateStatusMessage}
                            />
                        )}
                    </React.Fragment>
                )}
            </TourCardContentContainer>
        </TourCardContainer>
    );
};

TourCardEditable.propTypes = propTypes;
TourCardEditable.defaultProps = defaultProps;

export default TourCardEditable;
